import { render, staticRenderFns } from "./NotesLegend.vue?vue&type=template&id=261d48a9"
import script from "./NotesLegend.vue?vue&type=script&lang=js"
export * from "./NotesLegend.vue?vue&type=script&lang=js"
import style0 from "./NotesLegend.vue?vue&type=style&index=0&id=261d48a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports